import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { accessService } from '../../services/central-api/access';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    actingBodyId?: number;
    zIndex: number;
    disabled?: boolean;
    label?: string;
}

export default function WorkScheduleDropdown({ value, setValue, zIndex, actingBodyId, disabled, label }: Props) {
    const [selectableWorkSchedules, setSelectableWorkSchedules] = useState<{ label: string; value: number; }[]>([]);

    async function loadWorkSchedules(actingBodyId: number) {
        try {
            const workSchedules = await accessService.getWorkSchedulesSimplified(actingBodyId);
            setSelectableWorkSchedules(workSchedules.map((workSchedule) => {
                return {
                    value: workSchedule.id,
                    label: workSchedule.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            loadWorkSchedules(actingBodyId);
        }
    }, [actingBodyId]);

    return (
        <FilterDropdown
            label={label}
            items={selectableWorkSchedules}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
        />
    );
}
